module.exports = __webpack_public_path__ + "static/media/Amatic Bold.7dae3eb7.svg";